// extracted by mini-css-extract-plugin
export default {"floatingCta":"FloatingCTA_floatingCta__XfvK2","floatingCta__text":"FloatingCTA_floatingCta__text__SIB2L"};